import { render, staticRenderFns } from "./MortgageScoreReport.vue?vue&type=template&id=a706cc7c&scoped=true"
import script from "./MortgageScoreReport.vue?vue&type=script&lang=js"
export * from "./MortgageScoreReport.vue?vue&type=script&lang=js"
import style0 from "./MortgageScoreReport.vue?vue&type=style&index=0&id=a706cc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a706cc7c",
  null
  
)

export default component.exports